const features = [
  {
    id: 1,
    tag: 'Check in',
    title: 'Tap, scan, done.',
    description:
      "Members open the app, show their QR code, and attendance is marked instantly. No clipboards, no roll calls, no headaches. Leaders can also scan member QR codes directly.",
    mockupImage: 'https://res.cloudinary.com/damiraph/image/upload/v1765886421/Feature1_docefz.png',
  },
  {
    id: 2,
    tag: 'Live reporting',
    title: "See who's there in real time.",
    description:
      "Watch attendance roll in live from anywhere. Real-time dashboards update the moment a member checks in — so you always know who's in the building without being in the room.",
    mockupImage: 'https://res.cloudinary.com/damiraph/image/upload/v1765886420/Feature2_mq53br.png',
  },
  {
    id: 3,
    tag: 'Team management',
    title: 'One app. Every team.',
    description:
      "Whether you're managing 50 people or 50,000, structure your organisation into groups, departments and sub-teams. Assign leaders, delegate access and track everyone — zero chaos.",
    mockupImage: 'https://res.cloudinary.com/damiraph/image/upload/v1765886420/Feature3_hwp6ip.png',
  },
];

function FeatureRow({ feature, reverse }) {
  return (
    <div className="grid md:grid-cols-2 gap-12 lg:gap-20 items-center py-16 md:py-24 border-b border-gray-100 last:border-0">
      {/* Image */}
      <div className={`flex items-center justify-center ${reverse ? 'md:order-2' : 'md:order-1'}`}>
        <div className="relative w-full max-w-md rounded-2xl overflow-hidden border border-gray-200 bg-gray-50 shadow-sm">
          <img
            src={feature.mockupImage}
            alt={feature.title}
            className="w-full h-auto block"
          />
        </div>
      </div>

      {/* Text */}
      <div className={`space-y-4 ${reverse ? 'md:order-1' : 'md:order-2'}`}>
        <span
          className="inline-block text-xs font-semibold text-[#2228B6] bg-[#2228B6]/08 border border-[#2228B6]/15 px-3 py-1 rounded-full tracking-wide uppercase"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          {feature.tag}
        </span>
        <h3
          className="text-3xl sm:text-4xl font-bold text-gray-900 leading-tight"
          style={{ fontFamily: 'Inter, sans-serif' }}
        >
          {feature.title}
        </h3>
        <p className="text-base text-gray-500 leading-relaxed" style={{ fontFamily: 'Manrope, sans-serif' }}>
          {feature.description}
        </p>
      </div>
    </div>
  );
}

export default function FeatureCarousel() {
  return (
    <section id="features" className="bg-white px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        {/* Section header */}
        <div className="text-center pt-24 pb-4">
          <p
            className="text-xs font-semibold text-[#2228B6] uppercase tracking-widest mb-4"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Features
          </p>
          <h2
            className="text-4xl sm:text-5xl font-extrabold text-gray-900 mb-4"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Everything in one place
          </h2>
          <p className="text-lg text-gray-500 max-w-xl mx-auto" style={{ fontFamily: 'Manrope, sans-serif' }}>
            From check-in to reporting, Inked handles the whole attendance workflow.
          </p>
        </div>

        {/* Feature rows */}
        <div>
          {features.map((feature, index) => (
            <FeatureRow key={feature.id} feature={feature} reverse={index % 2 !== 0} />
          ))}
        </div>
      </div>
    </section>
  );
}
